import type { Security, UnifiedLiquidityResponse } from '@talos/kyoko';

/**
 * Resolves the symbol values used when a multileg instrument has a unified-liquidity leg.
 *
 * A UL response can contain several market-specific token entries for the same synthetic leg. The
 * multileg UI needs one representative security for market-selector enrichment and side calculations,
 * while the leg label should still show every distinct token the response represents.
 */
export function getUnifiedLiquidityLegSymbols(
  unifiedLiquidityToken: UnifiedLiquidityResponse | undefined,
  securitiesBySymbol: ReadonlyMap<string, Security>
) {
  const symbols = Array.from(new Set(unifiedLiquidityToken?.Tokens?.map(token => token.Symbol) ?? []));

  return {
    representativeSymbol: symbols[0],
    displaySymbols: symbols.map(symbol => securitiesBySymbol.get(symbol)?.DisplaySymbol ?? symbol).join(', '),
  };
}
